import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toHandlers as _toHandlers, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = { class: "o-button__text" }
const _hoisted_3 = { class: "o-button__text__elm" }
const _hoisted_4 = { class: "o-button__ico" }
const _hoisted_5 = ["id", "name", "placeholder", "required"]
const _hoisted_6 = { class: "o-form__validation" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "o-form__validation__required" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "o-form__validation__required" }
const _hoisted_9 = {
  key: 0,
  class: "o-form__validation__error"
}
const _hoisted_10 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")
  const _component_inputlabel = _resolveComponent("inputlabel")

  return (!$props.disabledIDs.includes($props.field.id))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass((!$props.field.inputClass) ? 'o-grid-12' : $props.field.inputClass)
      }, [
        (!$data.searchByVin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "o-button -icon-reverse -stroke -button-text",
              onClick: _cache[0] || (_cache[0] = $event => ($data.searchByVin=true))
            }, [
              _createElementVNode("span", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx._t('Rechercher marque, modèle et année par NIV')), 1 /* TEXT */)
              ]),
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_svgIco, {
                  icon: "search",
                  class: "o-ico icon-arrow-left-full"
                })
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.searchByVin && $props.field.inputLabel != '')
          ? (_openBlock(), _createBlock(_component_inputlabel, {
              key: 1,
              field: $props.field
            }, null, 8 /* PROPS */, ["field"]))
          : _createCommentVNode("v-if", true),
        ($data.searchByVin)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["o-form__item o-input-vindecode-finder", {'-loading': $data.loading, 'is-form-invalid': !$data.isValid}])
            }, [
              _withDirectives(_createElementVNode("input", _mergeProps({
                class: ["o-input", { 'readonly': $props.field.inputReadonly === true }]
              }, _toHandlers($data.readOnlyHandlers, true), {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($props.field.value) = $event)),
                id: 'input-'+$props.field.id,
                name: $props.field.inputName,
                placeholder: $props.field.inputPlaceholder,
                required: ($props.field.inputRequired === true) ? 'required' : false,
                onInput: _cache[2] || (_cache[2] = (...args) => ($options.vinDecode && $options.vinDecode(...args))),
                maxlength: "17",
                ref: "vindecodeInput"
              }), null, 16 /* FULL_PROPS */, _hoisted_5), [
                [_vModelText, $props.field.value]
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */),
                ($data.errorMsg=='')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx._t('Ce champ est invalide.')) + " " + _toDisplayString(_ctx._t('Il doit être composé de 17 caractères et ne doit pas contenir de o, i ou q.')), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "o-form__validation__error",
                      innerHTML: $data.errorMsg
                    }, null, 8 /* PROPS */, _hoisted_10))
              ])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}